import React, {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import Button from "../../../components/Button";
import AddRecordForm from "./addRecordForm";
import {
  storeReportSelectedControllerList,
  requestRecord,
} from "../../../redux/Actions/reports.actions";
import {
  getSelectedControllerList,
  getCreateReportData,
} from "../../../redux/Selectors/reports.selectors";

const ControllerListItem = ({controller, controllerIndex}) => {
  const {name, mac, records} = controller;
  const dispatch = useDispatch();
  const [fields, setFields] = useState([]);
  const controllerList = useSelector(getSelectedControllerList);
  const createReportData = useSelector(getCreateReportData);
  const {status} = createReportData;

  useEffect(() => {
    const callback = (data) => {
      const newData = data.map((eachData) => {
        const {name, identifier, last_calibration, selector} = eachData;
        return {
          name,
          identifier,
          last_calibration,
          selector,
          manually_observed: "",
          controller_observed: "",
        };
      });
      setFields(newData);
    };

    dispatch(requestRecord(mac, callback));
  }, [mac, dispatch]);

  const handleAddRecord = () => {
    let list = [...controllerList];
    let currentController = list[controllerIndex];
    currentController = {
      ...currentController,
      records: [...currentController.records, {fields}],
    };
    list[controllerIndex] = currentController;
    dispatch(storeReportSelectedControllerList(list));
  };

  const handleAddComment = () => {
    let list = [...controllerList];
    let currentController = list[controllerIndex];
    currentController = {
      ...currentController,
      comments: [...currentController.comments, ""],
    };
    list[controllerIndex] = currentController;
    dispatch(storeReportSelectedControllerList(list));
  };

  return (
    <div className="controller-list-item" data-cy="controllerListItem">
      <div
        className="d-flex justify-content-between align-items-center"
        style={{margin: "0px 1rem", flexWrap: "wrap"}}
      >
        <div
          style={{color: "#303030", fontWeight: "bold", margin: "0.5rem 0px"}}
          className="roboto-bold"
        >
          {name}
        </div>
        {status !== "under-review" && status !== "submitted" && (
          <div className="d-flex justify-content-end" style={{flexWrap: "wrap"}}>
            <div style={{margin: "0.5rem 5px"}}>
              <Button
                withRadius
                type="primary"
                onClick={handleAddComment}
                data-cy="addComment"
              >
                ADD COMMENT
              </Button>
            </div>
            {fields?.length > 0 && (
              <div style={{margin: "0.5rem 0px"}}>
                <Button
                  withRadius
                  type="info-small"
                  onClick={handleAddRecord}
                  data-cy="addRecord"
                >
                  ADD RECORD
                </Button>
              </div>
            )}
          </div>
        )}
      </div>
      {records.map((record, index) => {
        return (
          <AddRecordForm
            key={index}
            record={record}
            recordIndex={index}
            controllerIndex={controllerIndex}
          />
        );
      })}
    </div>
  );
};

export default ControllerListItem;
